/**
 * This file is used to store all the JavaScript event names used in the Valio User Data plugin.
 * Centralizing event names helps avoid typos and makes it easier to manage events across the codebase.
 *
 * We have two types of events:
 * 1. Internal app events (e.g., opening/closing modals, selecting lists). These are prefixed with 'valio:'.
 * 2. Firebase events that interact with firebase services. These are prefixed with 'firebase:'.
 */

export const CUSTOM_DATA_EVENTS = {
	MODAL_OPEN: 'valio:modal_open',
	MODAL_CLOSE: 'valio:modal_close',
	MODAL_TOGGLE_EDIT_MODE: 'valio:modal_toggle_edit_mode',
	RECIPE_SELECTED: 'valio:recipe_selected',
	RECIPE_SAVED_TO_LIST: 'firebase:recipe_saved_to_list',
	RECIPE_REMOVED_FROM_LIST: 'firebase:recipe_removed_from_list',
	RECIPE_MOVED_IN_LIST: 'firebase:recipe_moved_in_list',
	RECIPE_INITIAL_DATA_LOADED: 'firebase:recipe_initial_data_loaded',
	RECIPE_FETCHED: 'firebase:recipe_fetched',
	RECIPE_LIST_SELECTED: 'valio:recipe_list_selected',
	RECIPE_LIST_CREATED: 'firebase:recipe_list_created',
	RECIPE_LIST_DELETED: 'firebase:recipe_list_deleted',
	RECIPE_LIST_EDITED: 'firebase:recipe_list_edited',
	RECIPE_LIST_FETCHED: 'firebase:recipe_lists_fetched',
} as const;
